import React from 'react';
import { Button } from '../Button';
import Icons from '../../Icons/Icons';
import { cn } from '../../../../utils/styles';

interface IFakePagination {
  value: string;
  disabled?: boolean;
}

function FakePagination({ value, disabled }: IFakePagination) {
  return (
    <div className="grid gap-[5px] grid-cols-[auto,auto] text-muted-foreground items-center justify-start">
      <span className="text-sm text-muted-foreground">{value}</span>
      <div className="grid grid-cols-[34px,auto,34px] justify-start items-center">
        <Button variant="ghost" className={cn('p-[5px] h-[34px] opacity-30 pointer-events-none')}>
          <Icons.ArrowRight className="transform -scale-x-100" />
        </Button>
        <div className="w-[20px] text-center font-medium text-sm">1</div>
        <Button variant="ghost" className={cn('p-[5px] h-[34px]', { 'opacity-30 pointer-events-none': disabled })}>
          <Icons.ArrowRight />
        </Button>
      </div>
    </div>
  );
}

FakePagination.defaultProps = {
  disabled: false,
};

export default FakePagination;
